var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8122 6.35843C40.36 3.20662 45.1653 3.20663 47.7131 6.35844L50.0697 9.27382C51.6527 11.2321 54.2413 12.0732 56.673 11.4194L60.2932 10.446C64.207 9.39367 68.0946 12.2182 68.3032 16.2656L68.4962 20.0094C68.6258 22.5241 70.2256 24.7261 72.5772 25.6265L76.0782 26.9669C79.863 28.416 81.3479 32.9861 79.1377 36.3832L77.0933 39.5254C75.72 41.6361 75.72 44.3579 77.0933 46.4685L79.1377 49.6108C81.3479 53.0078 79.863 57.5779 76.0782 59.0271L72.5772 60.3675C70.2256 61.2679 68.6258 63.4698 68.4962 65.9846L68.3032 69.7284C68.0946 73.7758 64.207 76.6003 60.2932 75.548L56.673 74.5746C54.2413 73.9208 51.6527 74.7619 50.0697 76.7201L47.713 79.6355C45.1653 82.7873 40.36 82.7873 37.8122 79.6355L35.4555 76.7201C33.8725 74.7619 31.2839 73.9208 28.8522 74.5746L25.232 75.548C21.3182 76.6003 17.4306 73.7758 17.222 69.7284L17.029 65.9846C16.8994 63.4698 15.2996 61.2679 12.948 60.3675L9.44705 59.0271C5.66219 57.5779 4.17727 53.0078 6.38751 49.6108L8.43195 46.4685C9.80521 44.3579 9.80521 41.6361 8.43195 39.5254L6.38751 36.3832C4.17727 32.9861 5.66219 28.416 9.44705 26.9669L12.948 25.6265C15.2996 24.7261 16.8994 22.5241 17.029 20.0094L17.222 16.2656C17.4306 12.2181 21.3182 9.39367 25.232 10.446L28.8522 11.4194C31.2839 12.0732 33.8725 11.2321 35.4555 9.27382L37.8122 6.35843Z",
    fill: "url(#paint0_linear_3682_41288)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7335 51.2676C39.6827 52.3079 37.9901 52.3079 36.9393 51.2676L30.4018 44.7954C29.6299 44.0312 29.6299 42.784 30.4018 42.0198C31.1621 41.2671 32.3865 41.2663 33.1478 42.0179L38.8364 47.6339L52.3854 34.2205C53.1505 33.463 54.3836 33.4652 55.146 34.2254C55.9155 34.9926 55.9133 36.2396 55.1411 37.004L40.7335 51.2676Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3682_41288",
    x1: 82.1352,
    y1: 9.9603,
    x2: 82.1352,
    y2: 82.3696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#287A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickwave);
export default __webpack_public_path__ + "static/media/tick wave.88a4bc46af90f81da016395c98076cae.svg";
export { ForwardRef as ReactComponent };